import { createMutationHook, collapseParams } from '../client';
import { addCommodityWaitListOption } from '../services/CommodityService';

export const useCommodityAddCommodityWaitListOption = createMutationHook(
  collapseParams(
    collapseParams(addCommodityWaitListOption, 'requestBody', 'data'),
    'data',
    'customerId',
    'email',
    'name',
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['customerId', 'email', 'name'] },
    ],
  },
);
